module.exports = __webpack_public_path__ + "img/Costi Lavoro.b1c883e1.png";